import { render, staticRenderFns } from "./help-view.vue?vue&type=template&id=ccdc4d96&scoped=true&"
import script from "./help-view.vue?vue&type=script&lang=js&"
export * from "./help-view.vue?vue&type=script&lang=js&"
import style0 from "./help-view.vue?vue&type=style&index=0&id=ccdc4d96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdc4d96",
  null
  
)

export default component.exports